<template>
  <div>
    <v-client-table
      class="displayNonePagination"
      v-if="lignes.length"
      :data="lignes"
      :columns="columns"
      :options="options">
      <template #produit="{ row }">
        {{ row.libelle }}
      </template>
      <template #quantite="{ row }">
        <div class="is-pulled-right">
          {{ row.quantite }}
        </div>
      </template>
      <template #quantiteReceptionnee="{ row }">
        <div class="is-pulled-right">
          {{ row.quantite - row.quantiteResteARapprocher }}
        </div>
      </template>
      <template #solde="{ row }">
        <div class="is-pulled-right">
          {{ row.quantiteResteARapprocher }}
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';

export default {
  props: {
    lignes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    columns() {
      return ['produit', 'quantite', 'quantiteReceptionnee', 'solde'];
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      return {
        texts,
        headings: {
          produit: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.produit'),
          quantite: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.quantiteCommandee'),
          quantiteReceptionnee: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.quantiteReceptionnee'),
          solde: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.solde'),
        },
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPage: tableConfig.RESULTS_PER_PAGE,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        sortable: [],
        columnsClasses: {
          produit: 'min250px',
          quantite: 'colonneWidth130px',
          quantiteReceptionnee: 'colonneWidth130px',
          solde: 'colonneSelected',
        },
      };
    },
  },
};
</script>

<style>

</style>
